import React from 'react';
import { Box, Typography } from '@mui/material';
import { Gift, ListOrdered, Timer } from 'lucide-react';
import PageMetadata from '../components/PageMetadata';
import ToolTile from '../components/ToolTile';
import { toolTextSx } from '../components/ToolCard';

const DESCRIPTION = 'Free ADHD-friendly tools for focus, rewards, and prioritization. Try a Pomodoro timer, make a printable dopamine menu, or prioritize your tasks. No account needed.';
const URL = 'https://dopatize.com/tools';
const SCHEMA = { '@context': 'https://schema.org', '@type': 'CollectionPage', name: 'Free ADHD Tools', description: DESCRIPTION, url: URL,
  hasPart: [
    { '@type': 'WebApplication', name: 'Pomodoro timer and dopamenu', url: URL + '/pomodoro', isAccessibleForFree: true },
    { '@type': 'WebApplication', name: 'Task prioritizer', url: URL + '/prioritize', isAccessibleForFree: true },
    { '@type': 'WebApplication', name: 'Dopamine menu maker', url: URL + '/dopamenu', isAccessibleForFree: true },
  ],
};

export default function PublicTools() {
  return (
    <>
      <PageMetadata title="Free ADHD Tools | Dopatize" description={DESCRIPTION} url={URL} structuredData={SCHEMA} />
      <Typography component="h1" sx={{ fontSize: { xs: '1.3rem', sm: '1.7rem' }, lineHeight: 1.9, textAlign: 'center', m: 0 }}>Free ADHD tools</Typography>
      <Typography sx={{ ...toolTextSx, textAlign: 'center', color: 'secondary.main', mt: 2, mb: 4 }}>Pick a tool. No account needed.</Typography>
      <Box component="nav" aria-label="Free tools" sx={{ display: 'grid', gridTemplateColumns: { xs: 'repeat(2, minmax(0, 1fr))', sm: 'repeat(3, minmax(0, 1fr))', md: 'repeat(4, minmax(0, 1fr))' }, gap: { xs: 3, sm: 4 }, alignItems: 'start' }}>
        <ToolTile title="Pomodoro timer" to="/tools/pomodoro" icon={<Timer />} />
        <ToolTile title="Task prioritizer" to="/tools/prioritize" icon={<ListOrdered />} />
        <ToolTile title="Dopamenu" to="/tools/dopamenu" icon={<Gift />} />
      </Box>
    </>
  );
}
